import React, {useState} from 'react'
import {
    Box,
    Card,
    CardContent,
    IconButton,
    Typography,
    ClickAwayListener,
    Paper,
} from '@material-ui/core'
import MuiExpansionPanel from '@material-ui/core/Accordion'
import MuiExpansionPanelSummary from '@material-ui/core/AccordionSummary'
import MuiExpansionPanelDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MenuIcon from '@material-ui/icons/Menu'
import {withStyles, makeStyles} from '@material-ui/core/styles'
import {Link as RouterLink} from 'react-router-dom'

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        top: 48,
        right: 40,
        borderRadius: '0px',
        width: '460px',
        maxHeight: '80vh',
        overflow: 'auto',
        whiteSpace: 'normal',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '320px',
            maxHeight: '75vh',
            right: 0,
        },
    },
    circle: {
        boxSizing: 'border-box',
        color: theme.palette.common.white,
        height: '38px',
        width: '38px',
        '&:hover': {
            opacity: 0.8,
        },
    },
    routerLinktext: {
        textDecoration: 'none',
        paddingLeft: '25px',
        '&:hover': {
            opacity: 0.8,
            backgroundColor: theme.palette.grey.pale,
            transition: 'background-color 0.2s',
        },
    },
}))

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiExpansionPanel)

const ExpansionPanelSummary = withStyles(theme => ({
    root: {
        backgroundColor: theme.palette.common.white,
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: '3.5rem',
        '&$expanded': {
            backgroundColor: theme.palette.grey.pale,
            minHeight: '3.5rem',
        },
    },
    content: {
        '&$expanded': {
            margin: '0.75rem 0',
        },
    },
    expanded: {},
}))(MuiExpansionPanelSummary)

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiExpansionPanelDetails)

const MobileMenu = props => {
    const classes = useStyles()
    const {userrole} = props

    const [open, setOpen] = useState(false)
    const [expanded, setExpanded] = useState(false)

    const handleClick = () => {
        setOpen(!open)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    return (
        <>
            <ClickAwayListener onClickAway={handleClose}>
                <div>
                    <IconButton
                        id="mobile-menu"
                        aria-controls="mobile-menu"
                        aria-haspopup="true"
                        className={classes.circle}
                        size="small"
                        onClick={handleClick}
                    >
                        <MenuIcon />
                    </IconButton>

                    {open ? (
                        <Paper className={classes.paper}>
                            <div>
                                <Card>
                                    <CardContent>
                                        <Typography variant="h6">
                                            Navigation
                                        </Typography>
                                    </CardContent>
                                </Card>
                                <ExpansionPanel
                                    square
                                    expanded={expanded === 'panel1'}
                                    onChange={handleChange('panel1')}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography variant="subtitle1">
                                            Swiping
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <Box
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                width: '100%',
                                            }}
                                        >
                                            <RouterLink
                                                to={'/swiping'}
                                                className={
                                                    classes.routerLinktext
                                                }
                                            >
                                                <Typography variant="subtitle1">
                                                    Home{' '}
                                                </Typography>
                                            </RouterLink>
                                        </Box>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>

                                {[
                                    'Super Admin',
                                    'Department Admin',
                                    'Department Creator',
                                ].includes(userrole) ? (
                                    <ExpansionPanel
                                        square
                                        expanded={expanded === 'panel2'}
                                        onChange={handleChange('panel2')}
                                    >
                                        <ExpansionPanelSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2bh-content"
                                            id="panel2bh-header"
                                        >
                                            <Typography variant="subtitle1">
                                                Event Setup
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <RouterLink
                                                    to={'/eventsetup'}
                                                    className={
                                                        classes.routerLinktext
                                                    }
                                                >
                                                    <Typography variant="subtitle1">
                                                        Events{' '}
                                                    </Typography>
                                                </RouterLink>
                                                <RouterLink
                                                    to={'/swipeteams'}
                                                    className={
                                                        classes.routerLinktext
                                                    }
                                                >
                                                    <Typography variant="subtitle1">
                                                        Swiper Teams{' '}
                                                    </Typography>
                                                </RouterLink>
                                            </Box>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                ) : null}

                                {['Super Admin', 'Department Admin'].includes(
                                    userrole
                                ) ? (
                                    <ExpansionPanel
                                        square
                                        expanded={expanded === 'panel3'}
                                        onChange={handleChange('panel3')}
                                    >
                                        <ExpansionPanelSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel3bh-content"
                                            id="panel3bh-header"
                                        >
                                            <Typography variant="subtitle1">
                                                Manage Roles
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <RouterLink
                                                    to={'/manageroles'}
                                                    className={
                                                        classes.routerLinktext
                                                    }
                                                >
                                                    <Typography variant="subtitle1">
                                                        Department Roles
                                                    </Typography>
                                                </RouterLink>
                                                {userrole === 'Super Admin' ? (
                                                    <>
                                                        <RouterLink
                                                            to={
                                                                '/auditalldeptroles'
                                                            }
                                                            className={
                                                                classes.routerLinktext
                                                            }
                                                        >
                                                            <Typography variant="subtitle1">
                                                                Audit Roles
                                                            </Typography>
                                                        </RouterLink>
                                                        <RouterLink
                                                            to={
                                                                '/superadminroles'
                                                            }
                                                            className={
                                                                classes.routerLinktext
                                                            }
                                                        >
                                                            <Typography variant="subtitle1">
                                                                Super Admin
                                                                Roles
                                                            </Typography>
                                                        </RouterLink>
                                                    </>
                                                ) : null}
                                            </Box>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                ) : null}
                            </div>
                        </Paper>
                    ) : null}
                </div>
            </ClickAwayListener>
        </>
    )
}

export default MobileMenu
